import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";

const DEFAULT_COLORS = [
  "#235B67",
  "#227E79",
  "#23A487",
  "#23C998",
  "#70D460",
  "#A3C854",
];

export default function HorizontalBarChartCard({
  title,
  data,
  dataKey = "KgCO2e",
  nameKey = "name",
  height = 270,
  colors = DEFAULT_COLORS,
}) {
  return (
    <div className="card">
      <h2>{title}</h2>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart
          layout="vertical"
          data={data}
          margin={{ top: 0, right: 5, left: 35, bottom: 0 }}
          barSize={50}
        >
          <CartesianGrid strokeDasharray="2 2" />
          <XAxis type="number" />
          <YAxis dataKey={nameKey} type="category" />
          <Tooltip />
          <Legend />
          <Bar dataKey={dataKey} radius={[0, 5, 5, 0]} legendType="none">
            {data.map((_, index) => (
              <Cell key={index} fill={colors[index % colors.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}